import { createResponseComposition, context } from 'msw';

export const delayedResponse = createResponseComposition(undefined, [context.delay('real')]);
